<ng-container *transloco="let t">
  <ld-base-modal
    [title]="title()"
    [size]="'medium'"
    [isLoading]="isLoading()"
    [ariaLabelledBy]="'verify-borrower-modal-title'"
    (closeModal)="onCancel()"
  >
    <div modal-content>
      <p class="font-dm text-sm text-ld-neutral-600 mb-6">
        {{ description() }}
      </p>

      <form [formGroup]="ssnForm" (ngSubmit)="onVerify()">
        <div class="mb-4">
          <label for="ssn" class="block text-sm font-dm font-medium text-ld-neutral mb-2">
            {{ t('modalsVerifyBorrowerSsnLabel') }}
          </label>
          <input
            id="ssn"
            type="password"
            formControlName="ssn"
            maxlength="4"
            placeholder="••••"
            glance_masked="true"
            class="w-full px-4 py-3 text-center text-2xl tracking-[0.5em] border border-ld-border rounded-lg font-dm focus:outline-none focus:ring-2 focus:ring-ld-primary focus:border-transparent"
            [class.border-red-500]="ssnForm.get('commonFieldsSsn')?.invalid && ssnForm.get('commonFieldsSsn')?.touched"
            autocomplete="off"
          />
          @if (ssnForm.get('commonFieldsSsn')?.invalid && ssnForm.get('commonFieldsSsn')?.touched) {
            <p class="mt-1 text-xs font-dm text-red-600">{{ t('validationSsnLast4') }}</p>
          }
        </div>

        @if (errorMessage()) {
          <div class="p-3 bg-red-50 border border-red-200 rounded-lg mb-4">
            <p class="text-sm font-dm text-red-700">{{ errorMessage() }}</p>
          </div>
        }
      </form>
    </div>

    <div modal-footer>
      <button
        id="verify-borrower-cancel-btn"
        type="button"
        class="btn-outline-ld-purple"
        [disabled]="isLoading()"
        (click)="onCancel()"
      >
        {{ t('commonButtonsCancel') }}
      </button>
      <button
        id="verify-borrower-submit-btn"
        type="button"
        class="btn-primary-ld-purple"
        [disabled]="!ssnForm.valid || isLoading()"
        (click)="onVerify()"
      >
        @if (isLoading()) {
          <mat-spinner diameter="16" class="w-4! h-4! [&_circle]:stroke-white!"></mat-spinner>
        }
        {{ t('modalsVerifyBorrowerVerifyButton') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
